<cdk-accordion class="example-accordion">



    <cdk-accordion-item #accordionItem="cdkAccordionItem" class="example-accordion-item" role="button" tabindex="0"
        [attr.id]="'accordion-header-' + 1" [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + 1">

        <div class="example-accordion-item-header" (click)="accordionItem.toggle()">

            <span class="example-accordion-item-description">
                <b *ngIf="refund.number;else nonumber">{{refund.number}}</b> <ng-template #nonumber><b>НЕ
                        ПРИСВОЕН</b></ng-template>
                <mat-icon fontSet=" material-icons-outlined " class="status_indicator"
                    style="color:darkorange;margin-left: 4px;" *ngIf="refund.warn">
                    sms </mat-icon>

                <span *ngIf="refund.totalAmount">
                    <span [class]="itemsMinus ? 'orange' : 'primary'">
                        {{refund.totalAmount}} </span> на</span>
                <span class="primary"> {{refund.summa |
                    currency:'RUB':'symbol':'1.2-2':'ru'}}</span>

                <app-order-status-indicator *ngIf="check1cItems();else status" class="status_indicator"
                    [statusId]="refund.statusId" [onlyIcon]="true"></app-order-status-indicator>
                <ng-template #status>
                    <app-order-status-indicator *ngIf="checkItemslength()" class="status_indicator"
                        [statusId]="refund.statusId" [onlyIcon]="true"></app-order-status-indicator>
                </ng-template>

                <span *ngIf="refund.isPickup" class="pickup air">самовывоз</span>

                <p>
                    {{refund.buypoint}}
                </p>


                <p *ngIf="refund.orders1c?.length">
                    <span *ngIf="refund.orders1c">Заявки:</span><br>
                    <span *ngFor="let ord1c of refund.orders1c">

                        <app-order-status-indicator class="status_indicator" [statusId]="ord1c.statusId"
                            [onlyIcon]="true"></app-order-status-indicator>

                        {{ord1c.number}} <span *ngIf="ord1c.saleNumber">/ <b> РН
                                {{ord1c.saleNumber}} {{ord1c.saleStatus}}</b> </span>
                        <p>
                            на {{ord1c.dateDelivery | date:'dd.MM.YYYY'}}
                            <span *ngIf="ord1c.route" class="route_lable">, маршрут {{ord1c.route}} </span>

                            <span *ngIf="ord1c.dispatcher" class="route_lable">, экспедитор {{ord1c.dispatcher}} </span>

                            <span class="primary"> {{ord1c.amount}}</span>
                            шт. на
                            <span class="primary"> {{ord1c.summa |
                                currency:'RUB':'symbol':'1.2-2':'ru'}}</span>
                        </p>
                    </span>
                </p>



            </span>

            <mat-icon class="icon" *ngIf="!accordionItem.expanded">expand_more</mat-icon>
            <mat-icon class="icon" *ngIf="accordionItem.expanded">expand_less</mat-icon>

        </div>

        <div class="example-accordion-item-body" role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
            [attr.id]="'accordion-body-' + 1" [attr.aria-labelledby]="'accordion-header-' + 1">

            <p> {{refund.firm}} / {{refund.filial}}</p>

            <p>
                <span class="primary" *ngIf="refund.deliveryComment"> Коментарий по возврату: {{refund.deliveryComment}}
                </span>

                <span *ngIf="refund.note"><br> <span class="primary"> Коментарий: </span>
                    <span>{{refund.note}}</span>
                </span>

                <span class="warn" *ngIf="refund.error"><br>Ошибка: {{refund.error}}</span>
            </p>



            <span *ngIf="refund">
                <button [matBadge]="refund.messageCount" matBadgeColor="accent"
                    [matBadgeHidden]="refund.messageCount === 0" mat-flat-button color="primary"
                    [routerLink]="['/refundinfo', refund.id]" class="air-button">
                    Просмотр
                </button>

                <button mat-flat-button *ngIf="refund.statusId === 1" [routerLink]="['/edit-refund', refund.id]"
                    class="air-button">
                    редактировать
                </button>
                <app-refund-button-commit class="air-button" [(refund)]="refund"
                    [mode]="'delete'"></app-refund-button-commit>
                <app-refund-button-commit class="air-button" [(refund)]="refund"
                    [mode]="'commit'"></app-refund-button-commit>

                <button mat-flat-button color="primary" (click)="copyRefund(refund)" class="air-button">
                    Полная копия
                </button>


                <button
                    *ngIf="refund.statusId !== 1 && refund.statusId !== 2 && refund.statusId !== 4 && refund.statusId !== 8"
                    mat-flat-button color="primary" (click)="copyRefund(refund,false)" class="air-button">
                    Копия с вычерками
                </button>

            </span>

        </div>

    </cdk-accordion-item>

</cdk-accordion>